import React, {Component} from 'react';
import { Link } from 'react-router';
import Helmet from "react-helmet";

import GuideButton from '../../components/GuideButton';
import GuideHeader from '../../components/GuideHeader';

export default class PH extends Component {
  render() {
    const imageUrl = "https://blacksquare.nyc3.digitaloceanspaces.com/janes_colony/guide/guide_header_flowering_2.jpg";
    return (
      <div>
        <Helmet
          title="Jane's Colony"
          meta={ [
            { name: "description", content: "" },
            { property: "og:title", content: ''},
            { property: "og:url", content: ''},
            { property: "og:image", content: ''},
          ] }
        />
        <GuideHeader imageUrl={imageUrl} />
        <h2>
          PH
        </h2>
        <p>
          PH (Potential of Hydrogen) is a numeric scale used to determine the acidity or basicity of a solution. The PH level of your water and nutrients is important to your plants.An incorrect PH level will stop nutrients from traveling up the stem and into the plant. Your ideal PH level is 5.5 to 6.5. Always retest after adding nutrients as nutrients substantially change the PH, usually dropping it down. 
        </p>
        <p>
          You’ll need to get either a <a target="_blank" href="https://www.amazon.com/gp/product/B000BNKWZY/ref=as_li_tl?ie=UTF8&camp=1789&creative=9325&creativeASIN=B000BNKWZY&linkCode=as2&tag=blacksquare05-20&linkId=694a078832ec0c3846f925b2a20f025f">General Hydroponics pH Control Kit</a><img src="//ir-na.amazon-adsystem.com/e/ir?t=blacksquare05-20&l=am2&o=1&a=B000BNKWZY" width="1" height="1" alt="" className="amazon__pixel" /> or <a target="_blank" href="https://www.amazon.com/gp/product/B012UMLMJS/ref=as_li_tl?ie=UTF8&camp=1789&creative=9325&creativeASIN=B012UMLMJS&linkCode=as2&tag=blacksquare05-20&linkId=31fdafe2262bea1d0f21cf412e0cfc1b">Handheld Digital PH Meter</a><img src="//ir-na.amazon-adsystem.com/e/ir?t=blacksquare05-20&l=am2&o=1&a=B012UMLMJS" width="1" height="1" alt="" className="amazon__pixel" /> to measure this. We recommend the handheld meter as its much faster than using a test tube and dropper. 
        </p>
        <p>
          You’ll also need to buy PH up and PH down, solutions that you mix into your water and nutrients to change the PH. Add PH Down sparingly when measuring as it’s a much stronger additive, about 20x more additive is needed to come up than down. Because of this you’ll also want to buy more PH UP than PH down. 
        </p>
        <div className="guide__shopping-list">
          <h3>Shopping List</h3>

          <iframe className="amazon__iframe" marginWidth="0" marginHeight="0" scrolling="no" frameBorder="0" src="//ws-na.amazon-adsystem.com/widgets/q?ServiceVersion=20070822&OneJS=1&Operation=GetAdHtml&MarketPlace=US&source=ac&ref=tf_til&ad_type=product_link&tracking_id=blacksquare05-20&marketplace=amazon&region=US&placement=B012UMLMJS&asins=B012UMLMJS&linkId=64fe10594190b60268d8d5c47f2ee277&show_border=true&link_opens_in_new_window=true&price_color=333333&title_color=0066c0&bg_color=ffffff">
          </iframe>

            <iframe className="amazon__iframe" marginWidth="0" marginHeight="0" scrolling="no" frameBorder="0" src="//ws-na.amazon-adsystem.com/widgets/q?ServiceVersion=20070822&OneJS=1&Operation=GetAdHtml&MarketPlace=US&source=ac&ref=tf_til&ad_type=product_link&tracking_id=blacksquare05-20&marketplace=amazon&region=US&placement=B000BNKWZY&asins=B000BNKWZY&linkId=f4484ffe9ba2b03cb47b3735c6e5e269&show_border=true&link_opens_in_new_window=true&price_color=333333&title_color=0066c0&bg_color=ffffff">
            </iframe>

        </div>
        <GuideButton slugTo="temperature" />
      </div>
    )
  }
}





// WEBPACK FOOTER //
// ./src/content/guide/one_ph.js